//import "../_sass/main.scss";
import scrollama from "scrollama";
import InfiniteScroll from 'infinite-scroll';
import imagesLoaded from 'imagesloaded';

document.documentElement.classList.add('js');

document.querySelectorAll('.wp-block-group').forEach(group => {
    // Create the new container div
    const container = document.createElement('div');
    container.className = 'container';

    // Move all child nodes of .wp-block-group into the container
    while (group.firstChild) {
        container.appendChild(group.firstChild);
    }

    // Append the container into the group
    group.appendChild(container);
});

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll("a:not(.exclude)").forEach(function(link) {
        var hostRegex = new RegExp("/" + window.location.host + "/");

        if (!hostRegex.test(link.href)) {
            link.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(link.href, "_blank");
            });
            link.classList.add("external");
        }
    });

    const scroller = scrollama();
    const offset = 0.8;
    const stepSelector = '.wp-block-heading, .wp-block-group p, .wp-block-group h2, .wp-block-group h3, .wp-block-quote, .wp-block-group .wp-block-image, .entry-content .column, .block-intro h2, .block-intro nav, .block-intro .content-tab, .timeline, .block-condolence, .splide, .page-template-default .entry-content p';
    const steps = document.querySelectorAll(stepSelector);

    if(steps) {

        function setInitialActive() {
            const triggerLine = window.innerHeight * offset;
            steps.forEach(step => {
                const rect = step.getBoundingClientRect();

                // Wenn oberer Rand oberhalb oder auf dem Triggerpunkt liegt → aktivieren
                if (rect.top <= triggerLine) {
                    step.classList.add('active');
                } else {
                    step.classList.remove('active');
                }
            });
        }

        window.addEventListener('load', setInitialActive);
        window.addEventListener('resize', setInitialActive);

        scroller
            .setup({
                step: stepSelector,
                offset: offset, // → wenn oberer Rand bei 75% des Viewports ist
                once: false
            })
            .onStepEnter(response => {
                response.element.classList.add('active');
            })
            .onStepExit(response => {
                // Nur entfernen, wenn der Benutzer wieder hochscrollt
                if (response.direction === 'up') {
                    response.element.classList.remove('active');
                }
            });

    }

    const primaryMenu = document.getElementById('primary-menu');
    const menuToggle = document.getElementById('menu-toggle');
    const menuClose = primaryMenu.querySelector('.menu-item:last-child');

    menuToggle.classList.add("is-hidden");
    menuClose.classList.add("is-hidden");

    menuToggle.addEventListener("click", function(event) {
        event.preventDefault();
        primaryMenu.classList.remove("is-hidden");
        menuClose.classList.remove("is-hidden");
        menuToggle.classList.add("is-hidden");
    });

    menuClose.addEventListener("click", function(event) {
        event.preventDefault();
        primaryMenu.classList.add("is-hidden");
        menuClose.classList.add("is-hidden");
        menuToggle.classList.remove("is-hidden");
    });

    function setInitialMenu() {
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if(vw < 1000) {
            primaryMenu.classList.add("is-hidden");
            menuClose.classList.remove("is-hidden");
            menuToggle.classList.remove("is-hidden");
        } else {
            primaryMenu.classList.remove("is-hidden");
            menuClose.classList.remove("is-hidden");
            menuToggle.classList.add("is-hidden");
            window.addEventListener("scroll", () => {
                let scroll = window.scrollY;
                if(scroll > 200) {
                    menuToggle.classList.remove("is-hidden");
                    primaryMenu.classList.add("is-hidden");
                    menuClose.classList.add("is-hidden");
                } else {
                    menuToggle.classList.add("is-hidden");
                    primaryMenu.classList.remove("is-hidden");
                }
            });
        }
    }
    window.addEventListener('load', setInitialMenu);
    window.addEventListener('resize', setInitialMenu);

    function wrapLettersSimple(selector, className = 'split') {
        const el = document.querySelector(selector);
        if (!el) return;
        const text = el.innerText; // holt reinen Text (HTML wird entfernt)
        el.innerHTML = Array.from(text).map(ch => {
            // Leerzeichen als normales Leerzeichen belassen, sonst in span packen
            return ch === ' ' ? ' ' : `<span class="${className}">${ch}</span>`;
        }).join('');
    }

// Nutzung:
    wrapLettersSimple('#split-text');

    const letters = document.querySelectorAll('.split');
    let lastTimeout = 62;
    letters.forEach((el, i) => {
        setTimeout(() => {
            el.classList.add('active');
        }, i * 62); // 250 ms Abstand
        lastTimeout = i * 62;
    });

    setTimeout(function() {
        document.getElementById('masthead').classList.remove("is-invisible");
        document.getElementById('site-navigation').classList.remove("is-hidden");
        document.getElementById('block-candle').classList.remove("is-invisible");
    }, lastTimeout + 1500);

    const elem = document.querySelector('.grid');

    if(elem) {
        const iso = new Isotope(elem, {
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry'
        });

        imagesLoaded('.grid', () => iso.layout());

        const next_post_button = document.querySelectorAll('.next-posts a.view-more-button');
        if(next_post_button.length !== 0) {
            const infScroll = new InfiniteScroll('#infinite-scroll.grid', {
                path: '.next-posts a.view-more-button',
                append: '#infinite-scroll .grid-item',
                history: false,
                status: '.page-load-status',
                button: '.view-more-button',
                scrollThreshold: false,
            });

            infScroll.on('append', (response, path, items) => {
                items.forEach((item) => item.classList.add('active'));
                iso.appended(items);
                if (window.imagesLoaded) {
                    imagesLoaded(items, () => iso.layout());
                } else {
                    iso.layout();
                }
            });
        }
    }
});

let current_url = '';
let current_breadcrumb = '';

document.addEventListener('click', function (event) {

    /* ==========================
       MODAL OPEN
       ========================== */
    const openBtn = event.target.closest('.modal-open');
    if (openBtn) {
        event.preventDefault();
        event.stopPropagation();

        const modal        = document.getElementById('asge-modal');
        const content      = document.getElementById('asge-modal-content');
        const href         = openBtn.getAttribute('href');
        const containerSel = '#primary';

        modal.classList.toggle('open');

        current_url = window.location.href;
        window.history.replaceState(null, 'Title', href);

        // Content laden
        fetch(href)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const fragment = doc.querySelector(containerSel);

                if (fragment) {
                    content.innerHTML = fragment.innerHTML;
                    content.parentElement.classList.add('loaded');
                }
            });
        return;
    }

    /* ==========================
       MODAL CLOSE
       ========================== */
    const closeBtn = event.target.closest('.modal-close');
    if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();

        const modal   = document.getElementById('asge-modal');
        const content = document.getElementById('asge-modal-content');

        modal.classList.toggle('open');
        content.innerHTML = '';
        content.parentElement.classList.remove('loaded');

        // History zurücksetzen
        window.history.replaceState(null, 'Title', current_url);
    }

});


